export enum ProductTypeEnum {
  BulkCement = '0001',
  BagCement = '0002',
  Multiproduct = '0003',
  Cement = '0004',
  Aggregates = '0005',
  ReadyMix = '0006',
}

export enum ProductTypeIdEnum {
  ReadyMix = '6',
}
